import { useIsMaintenanceMode } from '@app/api';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { useTranslation } from 'react-i18next';
import BikeBroken from '@app/illu/Image/BikeBroken.svg';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: theme.marginBase * 12,
    paddingBottom: theme.marginBase * 12,
    backgroundColor: theme.colors.white,
    minHeight: '100vh',
  },
  content: {
    textAlign: 'center',
    maxWidth: theme.maxContentWidth.reduced,
  },
  title: {
    ...theme.fonts.h3,
    textAlign: 'center',
    marginTop: theme.marginBase * 8,
  },
  text: {
    ...theme.fonts.body,
    marginTop: theme.marginBase * 3,
  },
  illustration: {
    maxWidth: '100%',
  },
}));

export const MaintenanceGate = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const classes = useStyles();
  const { data } = useIsMaintenanceMode();
  const { t } = useTranslation('common');

  if (!data?.isMaintenanceMode) {
    return <>{children}</>;
  }
  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <img
          src={BikeBroken}
          alt="Maintenance"
          className={classes.illustration}
        />
        <h1 className={classes.title}>{t('maintenance.title')}</h1>
        <p className={classes.text}>{t('maintenance.text')}</p>
      </div>
    </div>
  );
};
